import 'config/webfont';
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { history, store } from 'redux/store';
import 'styles/styles.scss';
import AppWrapper from './AppWrapper';
import ErrorBoundaryContainer from './components/modules/ErrorBoundary/ErrorBoundaryContainer';
import { ConfigProvider } from './contexts/ConfigContext';
import reportWebVitals from './utils/reportWebVitals';

ReactDOM.render(
    <React.StrictMode>
        <ConfigProvider>
            <ErrorBoundaryContainer>
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <AppWrapper />
                    </ConnectedRouter>
                </Provider>
            </ErrorBoundaryContainer>
        </ConfigProvider>
    </React.StrictMode>
    ,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
